export enum transactionStatusEnum {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
  UNDER_REVIEW = "UNDER_REVIEW",
  TRANSFERRED = "TRANSFERRED",
  REFUND_REQUESTED = "REFUND_REQUESTED",
  REFUND_DENIED = "REFUND_DENIED",
}
